/**
 * Food Matching Utility
 * Matches user input to our local food database
 */

import foods from "../data/foods.json";

/**
 * Find foods in user input text
 * @param {string} userInput - Raw user input text
 * @returns {Array} Array of matched food items with nutrition data
 */
export function findFoodsInInput(userInput) {
  // Return empty array if no input
  if (!userInput || !userInput.trim()) {
    console.log("No user input provided");
    return [];
  }

  const input = userInput.toLowerCase();
  const matched = [];
  const seen = new Set();

  console.log("Searching for foods in:", input);

  // Check each food in database
  for (const [foodName, nutrition] of Object.entries(foods)) {
    // Check if food name appears in input
    if (input.includes(foodName)) {
      const key = foodName;
      if (!seen.has(key)) {
        seen.add(key);
        matched.push({
          name: foodName,
          ...nutrition,
        });
        console.log("Found food:", foodName);
      }
    }
  }

  // Also check for ALIAS mapping (e.g., "chicken" → "chicken breast")
  const aliases = {
    "chicken breast": "chicken",
    oatmeal: "oats",
  };

  for (const [alias, mainFood] of Object.entries(aliases)) {
    if (input.includes(alias) && !seen.has(mainFood)) {
      seen.add(mainFood);
      matched.push({
        name: mainFood,
        ...foods[mainFood],
      });
      console.log("Found food via alias:", mainFood);
    }
  }

  console.log("Total matched foods:", matched.length);
  return matched;
}

/**
 * Calculate total nutrition for a food list
 * @param {Array} foodList - Array of food objects
 * @returns {Object} Aggregated nutrition totals
 */
export function calculateTotalNutrition(foodList) {
  return foodList.reduce(
    (total, food) => ({
      calories: total.calories + (food.calories || 0),
      protein: total.protein + (food.protein || 0),
      carbs: total.carbs + (food.carbs || 0),
      fat: total.fat + (food.fat || 0),
    }),
    { calories: 0, protein: 0, carbs: 0, fat: 0 }
  );
}

/**
 * Suggest foods based on partial match
 * @param {string} query - User query
 * @returns {Array} Suggested foods
 */
export function suggestFoods(query) {
  const q = query.toLowerCase();
  return Object.keys(foods)
    .filter((food) => food.includes(q) || q.includes(food))
    .slice(0, 5);
}
